import { COLORS } from 'Components/utils/color/colors';

const NAV_POSITION_CLASSES = {
  bottom: {
    thControls: 'flex justify-end -mx-5 mt-10',
    thControl: 'mx-5',
  },
  center: {
    thInner: 'relative',
    thControls:
      'z-2 absolute flex justify-between pointer-events-none top-1/2 transform -translate-y-1/2 w-full',
    thControl:
      'pointer-events-auto before:absolute before:content-[""] before:h-120 before:right-0 before:h-40',
    thControlLeft: 'transform -translate-x-1/2',
    thControlRight: 'transform translate-x-1/2',
    thControlDisabled: 'invisible',
  },
  side: {
    thRoot: 'flex',
    thInner: 'flex-1',
    thControls: 'flex px-5',
    thControl: 'mx-5',
  },
  top: {
    thRoot: 'flex flex-col',
    thControls: 'flex justify-end -mx-5 mb-10 order-first',
    thControl: 'mx-5',
  },
};

export const themes = {
  default: ({ navPosition }) => {
    return {
      ...NAV_POSITION_CLASSES[navPosition],
      thControlColor: COLORS.LIGHT_SAND,
    };
  },
  brand: ({ navPosition }) => {
    return {
      ...NAV_POSITION_CLASSES[navPosition],
      thControlColor: COLORS.SAFFRON,
    };
  },
};
